// TypeScript type definitions for Location Heatmap

import { RackSummary, RackStructure } from '../rack-builder/types';

export interface LocationHeatmapRequest {
    startDate: string; // ISO date string
    endDate: string; // ISO date string
    locationPrefix: string; // 2 characters
    transType?: number | null;
    includeWeekends: boolean;
    includeHolidays: boolean;
}

export interface LocationHeatmapDto {
    binCode: string;
    locationPrefix: string;
    transactionCount: number;
    totalQuantity: number;
    uniqueDays: number;
    heatPercentile: number;
    heatLevel: number; // 1-5
    heatColor: string; // RGB color code
    firstTransaction?: string;
    lastTransaction?: string;
    periodDays: number;
    avgTransPerDay?: number;
}

/**
 * Nivå → farge for aktivitetsnivå 1-5. MÅ speile CASE-uttrykket som setter HeatColor
 * i LocationHeatmapRepository.cs — legenden tegnes fra denne, cellene får fargen fra backend.
 */
export const HEAT_LEVEL_COLORS: Record<number, string> = {
    1: 'rgb(37, 99, 235)',
    2: 'rgb(59, 130, 246)',
    3: 'rgb(250, 204, 21)',
    4: 'rgb(249, 115, 22)',
    5: 'rgb(220, 38, 38)',
};

export interface HeatmapFilterState {
    startDate: string;
    endDate: string;
    transType: number | null;
    includeWeekends: boolean;
    includeHolidays: boolean;
}

export interface LocationHeatmapState {
    racks: RackSummary[];
    selectedRackNumber: string | null;
    rackStructure: RackStructure | null;
    heatmapData: Map<string, LocationHeatmapDto>;
    filterState: HeatmapFilterState;
    isLoading: boolean;
    isLoadingHeatmap: boolean;
    error: string | null;
}
